import { useEffect, useRef, useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import Header from "../components/Header";

const plans = [
  {
    id: 1,
    name: "S.MEERA NexDrive",
    price: "₹2499",
    coverage: "Individual",
    additionalMembers: 0,
    benefits: [
      "8 Teleconsultation - General Physician(Instant)",
      "4 Teleconsultation - Ayurveda",
      "4 Teleconsultation - Homeopathy",
      "2 Teleconsultation - Choose from 18 Specialist",
      "2 Teleconsultation - Emotional Wellness",
      "2 Teleconsultation -  Dietician",
      "4 Video Consultation - General Physician",
      "1 Annual Health Checkup(Basic) - At Doorstep sample collection",
      // "₹1,000 Wallet Amount for Diagnostic Test and Packages",
      "1 Dental Checkup & Consultation",
      "1 Pet Health Video Consultation",
    ],
    eligibility: "Valid for individuals aged 18–65.",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Unlimited Recorded Fitness sessions",
    ],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹20,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹10,000",
    ],
    personal_accidents: ["Upto ₹15lakh coverage"],
    planCode: "SMEERANexDrive",
  },
  {
    id: 2,
    name: "S.Meera Nexivo",
    price: "₹3999",
    coverage: "Individual",
    additionalMembers: 0,
    benefits: [
      "8 Teleconsultation - General Physician(Instant)",
      "8 Teleconsultation - Ayurveda",
      "8 Teleconsultation - Homeopathy",
      "4 Teleconsultation - Choose from 18 Specialist",
      "4 Teleconsultation - Emotional Wellness",
      "4 Teleconsultation -  Dietician",
      "6 Video Consultation - General Physician",
      "1 Annual Health Checkup(Basic) - At Doorstep sample collection",
      "2 In-person General Physician Clinic Consultaion or Reimbursement upto ₹300 per Consultation for My Choice Doctor",
      "2 Dental Checkup & Consultation",
      "2 Pet Health Video Consultation",
    ],
    eligibility: "Valid for individuals aged 18–65.",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Unlimited Recorded Fitness sessions",
    ],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹20,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹10,000",
    ],
    personal_accidents: ["Upto ₹15lakh coverage"],
    planCode: "SMEERANexivo",
  },
  {
    id: 3,
    name: "S.Meera Nexivo Plus",
    price: "₹4999",
    coverage: "Family - 2 Adult +2 Children",
    additionalMembers: 3,
    benefits: [
      "12 Teleconsultation - General Physician(Instant)",
      "12 Teleconsultation - Ayurveda",
      "12 Teleconsultation - Homeopathy",
      "6 Teleconsultation - Choose from 18 Specialist",
      "4 Teleconsultation - Emotional Wellness",
      "4 Teleconsultation -  Dietician",
      "8 Video Consultation - General Physician",
      "1 Annual Health Checkup(Basic) - At Doorstep sample collection",
      "6 Consultations on In-person General Physician Clinic or Reimbursement upto ₹300 per Consultation for My Choice Doctor",
      "2 Dental Checkup & Consultation",
      "2 Pet Health Video Consultation",
    ],
    eligibility: "Valid for individuals aged 18–65.",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Unlimited Recorded Fitness sessions",
    ],
    // group_personal_accidental_rider: [
    //   "Sum Insured",
    //   "Accidental Death",
    //   "Permanent Total Disability (Upto 100% SI Paid on PTD)",
    // ],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹30,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹15,000",
    ],
    // personal_accidents: ["Upto 15lakh coverage - Primary Member"],
    accident_dealth: ["₹15L (Primary Member Only)"],
    planCode: "SMEERANexivoPlus",
  },
  {
    id: 4,
    name: "S.Meera Nexivo Prime",
    price: "₹6499",
    coverage: "Family - 2 Adults + 2 Children",
    additionalMembers: 3,
    benefits: [
      "12 Teleconsultation - General Physician(Instant)",
      "12 Teleconsultation - Ayurveda",
      "12 Teleconsultation - Homeopathy",
      "6 Teleconsultation - Choose from 18 Specialist",
      "4 Teleconsultation - Emotional Wellness",
      "4 Teleconsultation -  Dietician",
      "8 Video Consultation - General Physician",
      "1 Annual Health Checkup(Basic) - At Doorstep sample collection",
      "6 Consultations on In-person General Physician Clinic or Reimbursement upto ₹300 per Consultation for My Choice Doctor",
      "2 Dental Checkup & Consultation",
      "2 Pet Health Video Consultation",
    ],
    eligibility: "Valid for individuals aged 18–65.",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Unlimited Recorded Fitness sessions",
    ],
    // group_personal_accidental_rider: [
    //   "Sum Insured",
    //   "Accidental Death",
    //   "Permanent Total Disability (Upto 100% SI Paid on PTD)",
    // ],
    accident_dealth: ["₹15L (Primary Member Only)"],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹30,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹15,000",
    ],
    planCode: "SMEERANexivoPrime",
  },
  {
    id: 5,
    name: "S.Meera Nexivo Elite",
    price: "₹9499",
    coverage: "Family - 2 Adults + 2 Children",
    additionalMembers: 3,
    benefits: [
      "Unlimited Teleconsultation - General Physician(Instant)",
      "Unlimited Teleconsultation - Ayurveda",
      "Unlimited Teleconsultation - Homeopathy",
      "Unlimited Teleconsultation - Choose from 18 Specialist",
      "4 Teleconsultation - Emotional Wellness",
      "4 Teleconsultation -  Dietician",
      "8 Video Consultation - General Physician",
      "2 Annual Health Checkup(Basic) - At Doorstep sample collection",
      "8 Consultations on In-person General Physician Clinic or Reimbursement upto ₹300 per Consultation for My Choice Doctor",
      "4 Dental Checkup & Consultation",
      "2 Pet Health Video Consultation",
    ],
    eligibility: "Valid for individuals aged Upto 60.",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Recorded Fitness sessions",
    ],
    group_personal_accidental_rider: [
      "Sum Insured ₹5 lakh",
      "Accidental Death Cover",
      "Permanent Total Disability (Upto 100% SI Paid on PTD)",
      "Temporary Total Disability (Upto ₹500 for maximum 7 weeks)",
      "Children's Education (₹5K per children max upto 2 childrens)",
      "Accidental Hospitalization (Upto ₹20,000)",
    ],
    // personal_accidents: ["Personal Accident  (24*7)"],
    accident_dealth: ["₹15L (Primary Member Only)"],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹50,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹30,000",
    ],
    planCode: "SMEERANexivoElite",
  },
  {
    id: 6,
    name: "S.Meera Nexivo Infinity",
    price: "₹9999",
    coverage: "Individual",
    additionalMembers: 0,
    benefits: [
      "Unlimited Teleconsultation - General Physician(Instant)",
      "Unlimited Teleconsultation - Ayurveda",
      "Unlimited Teleconsultation - Homeopathy",
      "Unlimited Teleconsultation - Choose from 18 Specialist",
      "8 Teleconsultation - Emotional Wellness",
      "8 Teleconsultation -  Dietician",
      "8 Video Consultation - General Physician",
      "2 Annual Health Checkup(Basic) - At Doorstep sample collection",
      "6 Consultations on In-person General Physician Clinic or Reimbursement upto ₹300 per Consultation for My Choice Doctor",
      "2 Dental Checkup & Consultation",
    ],
    eligibility: "Valid for individuals aged Above 60 years",
    value_added_features: [
      "Unlimited Risk Assessment",
      "Unlimited Health Reminder",
      "Unlimited Recorded Fitness sessions",
    ],
    platform_benefits: [
      "Up to 50% OFF on Diagnostic Test & Packages. Benefit Limit: ₹50,000",
      "Flat 20% OFF on Prescribed Medicines. Benefit Limits: ₹30,000",
    ],
    planCode: "SMEERANexivoInfinity",
  },
];

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="shrink-0 mt-0.5"
  >
    <circle cx="8" cy="8" r="8" fill="black" Opacity="0.15" />
    <path
      d="M5 8l2 2 4-4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronIcon = ({ expanded }) => (
  <svg
    width="28" height="28" viewBox="0 0 28 28"
    fill="none"
    className="shrink-0 transition-transform duration-300 ease-in-out"
    style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)" }}
  >
    <circle cx="14" cy="14" r="13" stroke="#1a1a1a" strokeWidth="1.5" />
    <path d="M9.5 12l4.5 4.5 4.5-4.5" stroke="#1a1a1a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AccordionPanel = ({ expanded, children }) => (
  <div
    className="overflow-hidden transition-all duration-500 ease-in-out"
    style={{
      maxHeight: expanded ? "2000px" : "0px",
      opacity: expanded ? 1 : 0,
    }}
  >
    {children}
  </div>
);

const SectionBlock = ({ title, children, last = false, headerExtra }) => (
  <div className={last ? "" : "mb-5"}>
    <div className="mb-2.5">
      <span className="text-[18px] font-bold uppercase text-slate-900 tracking-widest">
        {title}
      </span>
      {headerExtra && (
        <div className="mt-1">
          {headerExtra}
        </div>
      )}
    </div>
    {children}
  </div>
);

// Generic bullet-list renderer used by every optional section
const BulletList = ({ items }) => (
  <div className="flex flex-col gap-2">
    {items.map((item, i) => (
      <div key={i} className="flex items-start gap-2">
        <i className="fa-solid fa-check text-xs text-[#C9A227]" />
        <span className="text-[15px] text-slate-700 leading-snug">
          {item}
        </span>
      </div>
    ))}
  </div>
);

const LEFT_COLUMN_FIELDS = [
  { key: "benefits", title: "Benefits" },
];

const RIGHT_COLUMN_FIELDS = [
  { key: "value_added_features", title: "Value Added Features" },
  { key: "group_personal_accidental_rider", title: "Group Personal Accidental" },
  { key: "road_side_assistance", title: "Road Side Assistance" },
  { key: "personal_accidents", title: "Personal Accidents" },
  { key: "accident_dealth", title: "Accidental Death" },
  { key: "platform_benefits", title: "Diagnostic & Pharmacy Benefits" },
];

const PlanCard = ({ plan, expanded, onToggle, openBuy }) => {
  const leftSections = LEFT_COLUMN_FIELDS.filter(
    (f) => Array.isArray(plan?.[f.key]) && plan[f.key].length > 0,
  );
  const rightSections = RIGHT_COLUMN_FIELDS.filter(
    (f) => Array.isArray(plan?.[f.key]) && plan[f.key].length > 0,
  );

  const [showExpertDropdown, setShowExpertDropdown] = useState(false);
  const expertRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (expertRef.current && !expertRef.current.contains(event.target)) {
        setShowExpertDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative overflow-hidden rounded-[40px] transition-all duration-500">
      <div
        className="absolute inset-0 animate-spin-conic"
        style={{
          background: "conic-gradient(#06b6d4,#8b5cf6,#ec4899,#06b6d4)",
        }}
      />

      {/* Inner Card */}
      <div className="relative bg-white rounded-[38px] h-full">
        {/* Header */}
        <div onClick={onToggle} className="cursor-pointer select-none px-10 py-5">
          <div className="flex  flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <span className="text-2xl font-bold text-slate-900 tracking-tight">
                  {plan.name}
                </span>
              </div>
              <div className="text-base font-semibold text-[#8A6D1D]">
                Coverage: {plan.coverage}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3 shrink-0">
                <div className="text-2xl font-extrabold text-slate-900">
                  {plan.price}
                </div>
                <div className="text-lg font-semibold text-slate-500">Inc. GST</div>
              </div>
              <div
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#C9A227] to-[#5C4E1D] px-8 py-3 font-semibold text-white cursor-pointer transition-all"
                onClick={(e) => {
                  e.stopPropagation();
                  openBuy(plan.planCode, plan.additionalMembers);
                }}
              >
                Buy Plan
              </div>
            </div>
            <ChevronIcon expanded={expanded} />
          </div>
        </div>

        {/* Content */}
        <AccordionPanel expanded={expanded}>
          <div className="relative border-t border-slate-100 px-6 pt-7 pb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left */}
              <div>
                {plan?.eligibility && (
                  <SectionBlock title="Eligibility">
                    <div className="flex gap-2 items-center">
                      <i className="fa-solid fa-check text-xs text-[#C9A227]" />
                      <p className="text-[15px] text-slate-500 leading-relaxed m-0">
                        {plan.eligibility}
                      </p>
                    </div>
                  </SectionBlock>
                )}

                {leftSections.map((section, idx) => (
                  <SectionBlock
                    key={section.key}
                    title={section.title}
                    last={idx === leftSections.length - 1}
                  >
                    <BulletList items={plan[section.key]} />
                  </SectionBlock>
                ))}
              </div>

              {/* Right */}
              <div className="mb-10">
                {rightSections.map((section, idx) => (
                  <SectionBlock
                    key={section.key}
                    title={section.title}
                    last={idx === rightSections.length - 1}
                    headerExtra={
                    section.key === "value_added_features" ? (
                      <div className="flex items-center gap-1.5">
                        <p className="text-[#57450a] text-[11px] whitespace-nowrap">
                          Powered By
                        </p>
                        <img
                          src="/assets/images/truvana.png"
                          className="h-4 w-auto"
                          alt="Powered by Truvana"
                        />
                      </div>
                    ) : null
                  }
                  >
                    <BulletList items={plan[section.key]} />
                  </SectionBlock>
                ))}
              </div>
            </div>

            <div className="absolute bottom-3 right-5" ref={expertRef}>
              <div
                className="flex gap-2 shadow-md hover:shadow-lg cursor-pointer px-3 py-2 rounded-lg bg-[#f4f1b0]"
                onClick={() => setShowExpertDropdown((prev) => !prev)}
              >
                <img
                  src="/assets/images/expert.png"
                  alt="expert"
                  width={24}
                  height={24}
                />
                <p className="font-semibold text-base">Talk to Expert</p>
              </div>

              {showExpertDropdown && (
                <div className="absolute right-0 bottom-full bg-gradient-to-br
                    from-[#D4CB2F]
                    to-[#8D8622] mb-2 inline-flex justify-start items-center gap-2 px-4 py-2 rounded-full border border-[#D4CB2F40]  text-black shadow-lg  min-w-[160px] z-20">
                  <a href="tel:9023723527">
                    <div className="flex space-x-2.5 items-center">
                      <span>
                        <svg
                          width={17}
                          height={17}
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.125 1.78125L6.375 4.78125C6.59375 5.28125 6.46875 5.875 6.03125 6.21875L4.5 7.5C5.53125 9.6875 7.3125 11.4688 9.5 12.5L10.7812 10.9688C11.125 10.5312 11.7188 10.4062 12.2188 10.625L15.2188 11.875C15.8125 12.0938 16.0938 12.75 15.9375 13.3438L15.1875 16.0938C15.0312 16.625 14.5625 17 14 17C6.25 17 0 10.75 0 3C0 2.4375 0.375 1.96875 0.90625 1.8125L3.65625 1.0625C4.25 0.90625 4.90625 1.1875 5.125 1.78125Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      <span className="text-white text-base leading-7 hover:underline common-trans capitalize">
                        9023723527
                      </span>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </div>
        </AccordionPanel>
      </div>
    </div>
  );
};

export default function PlanPage() {
  const [expandedId, setExpandedId] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T7742001XT2");
  const [isRider, setIsRider] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [memberCount, setMemberCount] = useState(0);
  const [showRC, setShowRC] = useState(false);
  const openBuy = (code, members = 0) => {
    setPlanCode(code);
    setOpenPopup(true);
    setIsRider(true);
    setMemberCount(members);
    setShowMember(false);
    setShowRC(false);
  };

  return (
    <>
    <Header/>
    
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-stone-50 via-amber-50 to-neutral-100 px-4 py-16 pt-[70px]">
      <div className="relative mx-auto w-full xl:w-[60%]">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="mb-4 text-3xl sm:text-4xl font-extrabold tracking-tight bg-gradient-to-r from-[#D4CB2F] via-[#E6DD57] to-[#55534F] bg-clip-text text-transparent md:text-5xl leading-tight">
            Healthcare built for
            <br />
            <span>every family</span>
          </h1>
          <p className="mx-auto max-w-lg text-base md:text-[20px] text-slate-500 leading-relaxed">
            Choose a plan that fits your life. Click any card to explore full
            details, benefits, and coverage — all in one place.
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              expanded={expandedId === plan.id}
              onToggle={() => setExpandedId((prev) => (prev === plan.id ? null : plan.id))}
              openBuy={openBuy}
            />
          ))}
        </div>
      </div>
      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={showMember}
        memberCount={memberCount}
        showRC={showRC}
      />
    </div>
    </>
  );
}